// stores/chatStore.js
import { defineStore } from 'pinia';

export const useChatStore = defineStore('chat', {
    state: () => ({
        messages: [], // { id, role: 'user'|'assistant', content: '', isStreaming: false }
        currentSessionId: 'default',
    }),

    actions: {
        addUserMessage(content) {
            this.messages.push({
                id: Date.now(),
                role: 'user',
                content,
            });
        },

        startAssistantMessage() {
            const msg = {
                id: Date.now(),
                role: 'assistant',
                content: '',
                isStreaming: true,
            };
            this.messages.push(msg);
            return msg;
        },

        appendToLastMessage(chunk) {
            const last = this.messages[this.messages.length - 1];
            if (last && last.role === 'assistant') {
                last.content += chunk;
            }
        },

        finishStreaming() {
            const last = this.messages[this.messages.length - 1];
            if (last) last.isStreaming = false;
        },
    },
});